import { render, staticRenderFns } from "./LeadRegistModal.vue?vue&type=template&id=6495a520&scoped=true&"
import script from "./LeadRegistModal.vue?vue&type=script&lang=js&"
export * from "./LeadRegistModal.vue?vue&type=script&lang=js&"
import style0 from "./LeadRegistModal.vue?vue&type=style&index=0&id=6495a520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6495a520",
  null
  
)

export default component.exports